import * as Constants from '../constants/Constants';
import {
  checkForPosterVersion,
  getAreaInSquareMeter,
  isWallartLiteWebLinkEdit,
  getDate,
  isPresoniseApp,
  getCategoryOfProduct,
  isSignageSuiteProduct,
  isEditLink
} from '../HelperFunctions/HelperFunctions';
import { string } from '../../localization';
import { getSelectedFont } from '../../redux/sideBarActions';
import {
  checkForDesignCompetition,
  isTurkeyAccount,
  isBelgiumAccount
} from '../HelperFunctions/SignageHelperFunctions';
import {
  canDisplayTemplateFolderPath,
  isInspirationDesigner,
  getRequestForQuotation,
  setGaUserId
} from '../../redux/finalCheckActions';
import { getActiveTabName } from '../TimerUtils/SidebarTimerUtils';
import { sendReviewOrderGA } from '../../redux/fabricCanvasActions';

export const createGA = () => {
  window.ga('create', process.env.REACT_APP_GOOGLE_ANALYTICS_ID, 'auto');
};

export const updateGADimension = (dimension, data) => {
  window.ga('set', dimension, data);
};

export const sendGAEvent = event => dispatch => {
  const label = dispatch(setDefaultLabel());
  window.ga('send', {
    hitType: 'event',
    eventCategory: dispatch(selectGoogleAnalyticsEventCategory()),
    eventAction: event,
    eventLabel: label
  });
};

export const selectGoogleAnalyticsEventCategory = inCategory => dispatch => {
  let category = inCategory;
  if (!category) {
    category = dispatch(getCategoryOfProduct());
  }

  if (isSignageSuiteProduct()) {
    if (isPresoniseApp(category)) {
      return Constants.GA_EVENT_CATEGORY.PERSONIZE;
    }
    return Constants.GA_EVENT_CATEGORY.JOB_CREATION;
  }
  if (
    category === Constants.NEW_POSTER_CATEGORY ||
    category === Constants.GA_EVENT_CATEGORY.POSTERS
  ) {
    return Constants.GA_EVENT_CATEGORY.POSTERS;
  }
  if (category === Constants.PERSONIZE_CATEGORY) {
    return Constants.GA_EVENT_CATEGORY.PERSONIZE;
  }
  return Constants.GA_EVENT_CATEGORY.JOB_CREATION;
};

// Designer launch Events
export const sendDesignerLaunchGAEvents = () => (dispatch, getState) => {
  if (getGaUserID()) {
    window.ga('set', 'userId', getGaUserID());
    dispatch(setGaUserId(getGaUserID()));
  }

  dispatch(sendCustomDimensionsGAEvents());

  const { envData } = getState().modal;
  window.ga('send', 'pageview', envData.page_title);

  const category = dispatch(getCategoryOfProduct());
  const eventCategory = dispatch(selectGoogleAnalyticsEventCategory(category));
  let eventLabel = envData.page_title;
  if (envData.wallart_lite_external_link) {
    eventLabel += ' | External Link';
  }
  if (envData.wallart_lite_web_link || isWallartLiteWebLinkEdit()) {
    eventLabel += ' |  Web Link';
  }

  if (isEditLink()) {
    if (envData.view_only_preview_mode) {
      eventLabel += ' | View Link';
    } else {
      eventLabel += ' | Edit Link';
    }
  }
  eventLabel += ` |  ${dispatch(setDefaultLabel())}`;
  window.ga(
    'send',
    'event',
    eventCategory,
    Constants.GA_EVENT_ACTIONS.DESIGNER_LAUNCH,
    eventLabel
  );
};

export const sendCustomDimensionsGAEvents = () => (dispatch, getState) => {
  const { envData, storeData } = getState().modal;
  const { project } = getState().finalCheck;
  const appName = !getState().modal.isSingleProduct
    ? storeData.applicationGroupName
    : envData.category;

  window.ga('set', 'dimension1', storeData.id);
  window.ga('set', 'dimension2', appName);

  if (project.projectGroupId != null) {
    window.ga('set', 'dimension3', project.projectGroupId);
  }

  window.ga('set', 'dimension4', '1.0.0');

  if (envData.category != null) {
    window.ga('set', 'dimension6', envData.category);
  }

  window.ga('set', 'dimension7', envData.platform);
};

// Product selection GA
export const selecteModelTypeGA = () => (dispatch, getState) => {
  const label = dispatch(setDefaultLabel());
  const eventLabelString = `${getState().modal.envData.category} | ${label}`;
  window.ga('send', {
    hitType: 'event',
    eventCategory: dispatch(selectGoogleAnalyticsEventCategory()),
    eventAction: Constants.GA_EVENT_ACTIONS.SELECT_MODEL_TYPE,
    eventLabel: eventLabelString
  });
};

// Designer GA Events
export const sendDesignPageGAEvents = () => (dispatch, getState) => {
  const { envData } = getState().modal;

  if (envData.category === Constants.NEW_POSTER_CATEGORY) {
    dispatch(sendGAEvent(Constants.GA_EVENT_ACTIONS.STEP_1_START_ORDER));
  } else {
    dispatch(sendGAEvent(Constants.GA_EVENT_ACTIONS.STEP_1_START_ORDER));
    dispatch(sendGAEvent(Constants.GA_EVENT_ACTIONS.STEP_2_DESIGN));
  }
};

export const gaOfPageChange = page => (dispatch, getState) => {
  const { category } = getState().modal.envData;
  const categoryType = dispatch(selectGoogleAnalyticsEventCategory());
  const label = dispatch(setDefaultLabel());
  let action;
  if (page === Constants.FINAL_CHECK_PAGE) {
    if (category === Constants.NEW_POSTER_CATEGORY) {
      action = Constants.GA_EVENT_ACTIONS.STEP_2_REVIEW_ORDER;
    } else {
      action = Constants.GA_EVENT_ACTIONS.STEP_3_REVIEW_ORDER;
    }
    dispatch(sendReviewOrderGA(false));
    return window.ga('send', {
      hitType: 'event',
      eventCategory: categoryType,
      eventAction: action,
      eventLabel: label
    });
  }
  return null;
};

// Tab GA Events
export const tabChangeGA = () => (dispatch, getState) => {
  let tabName = getActiveTabName(getState().sideBar.activeSideBarTab);
  tabName = tabName
    ? tabName.charAt(0).toUpperCase() + tabName.slice(1)
    : tabName;
  const { tabTime } = getState().sideBar;
  const { envData } = getState().modal;
  const defaultLabel = dispatch(setDefaultLabel());
  const label = `${tabName} - ${
    Constants.GA_EVENET_LABEL.TOTAL_TIME
  } | ${Math.round(
    (Date.now() - tabTime) / Constants.SECONDS_TIMER
  )} | ${defaultLabel}`;
  if (
    Date.now() - tabTime >
    Constants.SECONDS_TIMER * envData.minimum_tab_duration
  ) {
    window.ga('send', {
      hitType: 'event',
      eventCategory: dispatch(selectGoogleAnalyticsEventCategory()),
      eventAction: Constants.GA_EVENT_ACTIONS.DESIGNER_TIME_USAGE,
      eventLabel: label
    });
  }
};

export const pageChangeGA = () => (dispatch, getState) => {
  const { tabTime } = getState().sideBar;
  const { envData } = getState().modal;
  const defaultLabel = dispatch(setDefaultLabel());

  const label = `${Constants.GA_EVENET_LABEL.REVIEW_ORDER} - ${
    Constants.GA_EVENET_LABEL.TOTAL_TIME
  } | ${Math.round(
    (Date.now() - tabTime) / Constants.SECONDS_TIMER
  )} | ${defaultLabel}`;

  if (
    Date.now() - tabTime >
    Constants.SECONDS_TIMER * envData.minimum_tab_duration
  ) {
    window.ga('send', {
      hitType: 'event',
      eventCategory: dispatch(selectGoogleAnalyticsEventCategory()),
      eventAction: Constants.GA_EVENT_ACTIONS.DESIGNER_TIME_USAGE,
      eventLabel: label
    });
  }
};

export const sideBarTab = () => (dispatch, getState) => {
  const { tabTime } = getState().sideBar;
  const { envData } = getState().modal;
  const defaultLabel = dispatch(setDefaultLabel());

  let { tabName } = getState().sideBar;
  tabName = tabName.charAt(0).toUpperCase() + tabName.slice(1);
  const label = `${tabName} - ${
    Constants.GA_EVENET_LABEL.TOTAL_TIME
  } | ${Math.round(
    (Date.now() - tabTime) / Constants.SECONDS_TIMER
  )} | ${defaultLabel}`;

  if (
    Date.now() - tabTime >
    Constants.SECONDS_TIMER * envData.minimum_tab_duration
  ) {
    window.ga('send', {
      hitType: 'event',
      eventCategory: dispatch(selectGoogleAnalyticsEventCategory()),
      eventAction: Constants.GA_EVENT_ACTIONS.DESIGNER_TIME_USAGE,
      eventLabel: label
    });
  }
};

export const getInspirationCategoriesAsString = () => (dispatch, getState) => {
  const filterIds = getState().finalCheck.project.inspirationFilterIds;
  const matchedCategories = getState().sideBar.inspirationCategory.filter(
    inspirationFilter => filterIds.indexOf(inspirationFilter.id) > -1
  );

  let inspiratonCategorieString = '';
  matchedCategories.forEach((matchedCategory, index) => {
    if (index) {
      inspiratonCategorieString += ', ';
    }
    inspiratonCategorieString += matchedCategory.category;
  });
  return inspiratonCategorieString;
};

export const gaOfSelectingInspiration = () => (dispatch, getState) => {
  const category = dispatch(selectGoogleAnalyticsEventCategory());
  const inspiratonCategorieString = dispatch(
    getInspirationCategoriesAsString()
  );
  const label = `${
    getState().finalCheck.project.parentId
  } | ${inspiratonCategorieString} | ${dispatch(setDefaultLabel())}`;

  window.ga('send', {
    hitType: 'event',
    eventCategory: category,
    eventAction: Constants.GA_EVENT_ACTIONS.SELECT_INSPIRATION_TEMPLATES,
    eventLabel: label
  });
};

export const gaOfUsedInspirationTemplates = () => (dispatch, getState) => {
  const category = dispatch(selectGoogleAnalyticsEventCategory());
  const inspiratonCategorieString = dispatch(
    getInspirationCategoriesAsString()
  );
  const label = `${
    getState().finalCheck.project.parentId
  } | ${inspiratonCategorieString} | ${dispatch(setDefaultLabel())}`;

  window.ga('send', {
    hitType: 'event',
    eventCategory: category,
    eventAction: Constants.GA_EVENT_ACTIONS.USED_INSPIRATION_TEMPLATES,
    eventLabel: label
  });
};

export const solidColorGA = element => dispatch => {
  const category = dispatch(selectGoogleAnalyticsEventCategory());
  const itemInfo = `${Constants.SOLID_COLOR_TYPE} | ${element} | ${dispatch(
    setDefaultLabel()
  )}`;
  window.ga('send', {
    hitType: 'event',
    eventCategory: category,
    eventAction: Constants.GA_EVENT_ACTIONS.ADD_BACKGROUND,
    eventLabel: itemInfo,
    eventValue: new Date().getTime()
  });
};

export const gaForCanvasAction = (placing, isRecolor) => dispatch => {
  const { imageSource, userPhotoType, placeableType } = placing;
  const isPhoto = Object.prototype.hasOwnProperty.call(
    placing.placeable,
    'isPhoto'
  )
    ? placing.placeable.isPhoto
    : null;
  const eventCategory = dispatch(selectGoogleAnalyticsEventCategory());

  let itemEvent = '';
  let itemId = '';
  if (
    imageSource === Constants.LOCAL_IMAGE_SOURCE ||
    imageSource === Constants.DROPBOX_IMAGE_SOURCE ||
    imageSource === Constants.INSTAGRAM_IMAGE_SOURCE
  ) {
    itemEvent = Constants.GA_EVENT_ACTIONS.ADD_CUSTOM_CONTENT;
    if (userPhotoType === Constants.USER_PHOTO_SCENE_TYPE) {
      itemId = Constants.BACKGROUND_KEY;
    } else if (userPhotoType === Constants.USER_PHOTO_ELEMENT_TYPE) {
      if (isPhoto) {
        itemId = Constants.PHOTO_KEY;
      } else {
        itemId = Constants.ELEMENT_KEY;
      }
    }
  } else if (
    placeableType === Constants.SCENE_KEY ||
    (placeableType === Constants.USER_PHOTO_TYPE &&
      userPhotoType === Constants.USER_PHOTO_SCENE_TYPE)
  ) {
    itemEvent = Constants.GA_EVENT_ACTIONS.ADD_BACKGROUND;
    itemId = placing.placeableId ? placing.placeableId : placing.mediaId;
  } else if (
    placeableType === Constants.ELEMENT_KEY ||
    (placeableType === Constants.USER_PHOTO_TYPE &&
      userPhotoType === Constants.USER_PHOTO_ELEMENT_TYPE)
  ) {
    if (isPhoto) {
      itemEvent = Constants.GA_EVENT_ACTIONS.ADD_PHOTO;
      itemId = placing.placeableId ? placing.placeableId : placing.mediaId;
    } else {
      itemEvent = Constants.GA_EVENT_ACTIONS.ADD_OBJECT;
      itemId = placing.placeableId ? placing.placeableId : placing.mediaId;
    }
  } else if (placeableType === Constants.TEXT_ELEMENT_TYPE) {
    itemEvent = Constants.GA_EVENT_ACTIONS.ADD_TEXT;
    const shadow =
      placing.placeable.shadow === true ? 'shadow:yes' : 'shadow:no';
    itemId = `${shadow} | ${placing.placeable.fontId} | ${
      dispatch(getSelectedFont(placing.placeable.fontId)).font_family
    } | `;
  }
  if (isRecolor) {
    itemEvent = Constants.GA_EVENT_ACTIONS.IMAGE_RECOLOR;
  }

  if (itemId !== '' && itemEvent !== '') {
    const itemInfo = setItemInfo(placeableType, itemId, placing.placeable);
    const label = itemInfo + dispatch(setDefaultLabel());
    return window.ga('send', {
      hitType: 'event',
      eventCategory,
      eventAction: itemEvent,
      eventLabel: label,
      eventValue: new Date().getTime()
    });
  }
  return null;
};

const setItemInfo = (type, itemId, element) => {
  if (type === Constants.TEXT_ELEMENT_TYPE) {
    return `${element.text} | ${itemId}`;
  }
  const extensionPath = Object.prototype.hasOwnProperty.call(
    element,
    'printableImageContentType'
  )
    ? element.printableImageContentType
    : null;
  let extension = '';
  if (extensionPath) {
    const res = extensionPath.split('/');
    extension = `${res[res.length - 1]} | `;
  }
  const itemName = element.name || '';
  const imageDetails = `${getPlaceableType(element)} : ${element.themeName}`;
  return `${imageDetails} | ${itemId} | ${itemName} | ${extension} | `;
};

const getPlaceableType = item => {
  switch (item.imageSource) {
    case Constants.PATTERN_DESIGN_IMAGE_SOURCE:
      return 'Pattern Design';
    case Constants.DREAMSTIME_IMAGE_SOURCE:
      return Constants.DREAMSTIME;
    case Constants.UNSPLASH_IMAGE_SOURCE:
      return Constants.UNSPLASH;
    case Constants.VECTEEZY_IMAGE_SOURCE:
      return Constants.VECTEEZY;
    case Constants.GETTY_IMAGE_SOURCE:
      return Constants.GETTY_IMAGE;
    case Constants.I_STOCK_IMAGE_SOURCE:
      return Constants.I_STOCK;
    case Constants.ADOBE_STOCK_IMAGE_SOURCE:
      return Constants.ADOBE_STOCK;
    case Constants.LOCAL_IMAGE_SOURCE:
      return Constants.FROM_COMPUTER;
    case Constants.DROPBOX_IMAGE_SOURCE:
      return Constants.FROM_DROPBOX;
    case Constants.INSTAGRAM_IMAGE_SOURCE:
      return Constants.FROM_INSTAGRAM;
    case Constants.HP_MOSAIC_IMAGE_SOURCE:
      return Constants.HP_MOSAIC;
    case Constants.HOSTED_CONTENT_IMAGE_SOURCE:
      return Constants.HOSTED_CONTENT;
    default:
      return item.themeName;
  }
};

export const GAForTextTabClick = () => dispatch => {
  dispatch(sendGAEvent(Constants.GA_EVENT_ACTIONS.CLICK_ON_ADD_TEXT));
};

// TopBar GA Events
export const gaOfHelpWindow = action => dispatch => {
  window.ga('send', {
    hitType: 'event',
    eventCategory: dispatch(selectGoogleAnalyticsEventCategory()),
    eventAction: action,
    eventLabel: dispatch(checkForPosterVersion())
  });
};

export const startAndFinishTourGA = action => dispatch => {
  const label = dispatch(setDefaultLabel());
  window.ga('send', {
    hitType: 'event',
    eventCategory: dispatch(selectGoogleAnalyticsEventCategory()),
    eventAction: action,
    eventLabel: label
  });
};

export const sendShareGAEvents = currentShareMedia => dispatch => {
  let typeOfRRSS = '';
  switch (currentShareMedia) {
    case 'facebook_connect':
      typeOfRRSS = 'Facebook';
      break;
    case 'linked_in':
      typeOfRRSS = 'Linkedin';
      break;
    case 'twitter':
      typeOfRRSS = 'Twitter';
      break;
    case 'pinterest':
      typeOfRRSS = 'Pinterest';
      break;
    default:
      typeOfRRSS = 'Email';
      break;
  }

  const label = `${typeOfRRSS} | ${dispatch(setDefaultLabel())}`;
  window.ga('send', {
    hitType: 'event',
    eventCategory: dispatch(selectGoogleAnalyticsEventCategory()),
    eventAction: Constants.GA_EVENT_ACTIONS.SHARE_JOB_PROJECT,
    eventLabel: label
  });
};

export const shareProjectGA = socialMedia => dispatch => {
  const label = `${socialMedia} | ${dispatch(setDefaultLabel())}`;
  window.ga('send', {
    hitType: 'event',
    eventCategory: dispatch(selectGoogleAnalyticsEventCategory()),
    eventAction: Constants.GA_EVENT_ACTIONS.SHARE_JOB_PROJECT,
    eventLabel: label
  });
};

export const saveGAEvent = action => dispatch => {
  dispatch(sendGAEvent(action));
};

export const sendLoginGAEvents = action => dispatch => {
  dispatch(sendGAEvent(action));
};

// Edit Design GA
export const onEditDesignGA = () => dispatch => {
  dispatch(sendGAEvent(Constants.GA_EVENT_ACTIONS.GO_BACK_TO_EDIT_DESIGN));
};

// Vanilla RIP GA Events
export const gaOfHittingRipLink = label => dispatch => {
  const labelName = dispatch(setDefaultLabel());
  const categoryOfEvent = dispatch(selectGoogleAnalyticsEventCategory());
  let itemEvent;

  if (label === string.HP_CLICK) {
    itemEvent = Constants.GA_EVENT_ACTIONS.HIT_LINK_TO_DOWNLOAD_HP_CLICK;
  } else if (label === string.HP_SMART_STREAM_KEY) {
    itemEvent = Constants.GA_EVENT_ACTIONS.HIT_LINK_TO_DOWNLOAD_SMART_STREAM;
  }
  window.ga('send', {
    hitType: 'event',
    eventCategory: categoryOfEvent,
    eventAction: itemEvent,
    eventLabel: labelName
  });
};

export const GAForSelectedRIP = RIPName => dispatch => {
  const eventAction = `${Constants.GA_EVENT_ACTIONS.DOWNLOAD_ORDER_THROUGH_RIP}  ${RIPName}`;
  const label = dispatch(setDefaultLabel());
  window.ga('send', {
    hitType: 'event',
    eventCategory: Constants.GA_EVENT_CATEGORY.JOB_ORDER_DOWNLOAD,
    eventAction,
    eventLabel: label
  });
};

// Add to order GA
export const sendPrintGA = projectName => (dispatch, getState) => {
  const designCompetition = dispatch(checkForDesignCompetition());
  const isTurkey = dispatch(isTurkeyAccount());
  const isBelgium = dispatch(isBelgiumAccount());
  let gaAction = Constants.GA_EVENT_ACTIONS.JOB_SUBMITTED;
  const requestForQuotation = dispatch(getRequestForQuotation());
  if (getState().modal.envData.wallart_lite_web_link) {
    if (requestForQuotation) {
      gaAction = Constants.GA_EVENT_ACTIONS.REQUEST_FOR_QUOTATION;
    } else {
      gaAction = Constants.GA_EVENT_ACTIONS.ADD_TO_CART;
    }
  } else if (canDisplayTemplateFolderPath(getState) && isEditLink()) {
    gaAction = Constants.GA_EVENT_ACTIONS.SAVE_TEMPLATE;
  } else if (canDisplayTemplateFolderPath(getState)) {
    gaAction = Constants.GA_EVENT_ACTIONS.ADD_TEMPLATE;
  } else if (isInspirationDesigner(getState)) {
    gaAction = Constants.GA_EVENT_ACTIONS.CREATE_INSPIRATION;
  } else if (isTurkey || isBelgium) {
    gaAction = Constants.GA_EVENT_ACTIONS.ORDER_DESIGN;
    if (designCompetition) {
      gaAction = Constants.GA_EVENT_ACTIONS.SUBMIT_YOUR_DESIGN;
    }
  } else if (requestForQuotation) {
    gaAction = Constants.GA_EVENT_ACTIONS.REQUEST_FOR_QUOTATION;
  }

  const { projectWidth, projectHeight } = getState().home;
  const areaInSQM = getAreaInSquareMeter(projectWidth, projectHeight);
  const projectInfo = `${projectName} | ${areaInSQM}`;
  const label = `${projectInfo} | ${
    getState().finalCheck.project.category
  } | ${dispatch(setDefaultLabel())}`;
  window.ga('send', {
    hitType: 'event',
    eventCategory: dispatch(selectGoogleAnalyticsEventCategory()),
    eventAction: gaAction,
    eventLabel: label
  });
  return Promise.resolve();
};

// Feedback GA Events
export const feedbackGAEvents = (rating, action, inLabelName) => () => {
  let labelName = inLabelName;
  const feedbackDate = getDate();
  if (getGaUserID()) {
    labelName += ` | GAUserID:${getGaUserID()}`;
  }

  updateGADimension('dimension9', rating);
  updateGADimension('dimension10', feedbackDate);
  window.ga('send', {
    hitType: 'event',
    eventCategory: Constants.GA_EVENT_CATEGORY.FEEDBACK,
    eventAction: action,
    eventLabel: labelName
  });
};

const getGaUserID = () => {
  const cookieDetails = document.cookie.match(/_ga=(.+?);/);
  if (cookieDetails) {
    return document.cookie
      .match(/_ga=(.+?);/)[1]
      .split('.')
      .slice(-2)
      .join('.');
  }
  return false;
};

const setDefaultLabel = () => (dispatch, getState) => {
  const envPlatform = getState().modal.envData.platform;
  let platform;
  if (envPlatform === Constants.ANDROID) {
    platform = Constants.MOBILE;
  } else if (envPlatform === Constants.IOS) {
    platform = Constants.MOBILE;
  } else {
    platform = Constants.DESKTOP;
  }
  const posterVersionName = dispatch(checkForPosterVersion());

  let defaultLabel = platform;
  if (posterVersionName) {
    defaultLabel += ` | ${posterVersionName}`;
  }
  if (getGaUserID()) {
    defaultLabel += ` | GAUserID:${getGaUserID()}`;
  }
  return defaultLabel;
};
